define((require) => {
    "use strict";

    var WidgetCreatedActivity               = require("editor/ui/experience/editor/activity/WidgetCreatedActivity"),
        WidgetPropertiesChangedActivity     = require("editor/ui/experience/editor/activity/WidgetPropertiesChangedActivity"),
        SceneDeletedActivity                = require("editor/ui/experience/editor/activity/SceneDeletedActivity"),
        WidgetDeletedActivity               = require("editor/ui/experience/editor/activity/WidgetDeletedActivity"),
        WidgetsGroupedActivity              = require("editor/ui/experience/editor/activity/WidgetsGroupedActivity"),
        WidgetsUngroupedActivity            = require("editor/ui/experience/editor/activity/WidgetsUngroupedActivity"),
        DynamicProductWidgetCreatedActivity = require("editor/ui/experience/editor/activity/DynamicProductWidgetCreatedActivity");


    /**
     * Convenience class holding all the editor activities.
     *
     * @class EditorActivity
     * @author Kim
     */
    return {
        WidgetCreatedActivity: WidgetCreatedActivity,
        WidgetDeletedActivity: WidgetDeletedActivity,
        WidgetPropertiesChangedActivity: WidgetPropertiesChangedActivity,
        SceneDeletedActivity: SceneDeletedActivity,
        WidgetsGroupedActivity: WidgetsGroupedActivity,
        WidgetsUngroupedActivity: WidgetsUngroupedActivity,
        DynamicProductWidgetCreatedActivity: DynamicProductWidgetCreatedActivity
    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/editor/activity/EditorActivities.js